import React,{ useEffect, useState } from "react";
import "./user.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchThemeData } from '../../admin/themeSlice';
import { requestBackToMainGrid } from '../uiSlice';
import { useLocation } from "react-router-dom";

function USER({children }) {
  const dispatch = useDispatch();
    const location = useLocation();

    const { companyLogoUrl, backButtonUrl, mainDaySubViewOpen } = useSelector((state) => state.ui);
    const [logoUrl,setLogoUrl]=useState("");
    const [backUrl,setBackUrl]=useState("");

    const { user } = useSelector(state => state.auth);
    const { status: themeStatus, data: themeData } = useSelector(state => state.theme);
 
    const fromMobileAppInUrl =
      String(new URLSearchParams(location.search).get("fromMobileApp") || "").toLowerCase() ===
      "true";
    const fromMobileAppInUser = String(user?.fromMobileApp || "").toLowerCase() === "true";
    const persistedFromMobileApp = (() => {
      try {
        const persisted = JSON.parse(
          sessionStorage.getItem("userData") || "{}"
        );
        return String(persisted?.fromMobileApp || "").toLowerCase() === "true";
      } catch {
        return false;
      }
    })();
    const isFromMobileApp = fromMobileAppInUrl || fromMobileAppInUser || persistedFromMobileApp;


  const applyCustomTheme = (theme) => {
    if (!theme) return;
    const set = (k, v) =>
      document.documentElement.style.setProperty(k, v != null ? String(v) : "");

    // Core theme variables (no hardcoded defaults; they come from themeset)
    set("--text-color", theme.text_color);
    set("--box-bg-color", theme.box_bg_color);
    set("--box-text-color", theme.box_text_color);
    set("--popup-color", theme.popup_color);

    // Legacy variables (still used in a few places)
    set("--ui-color-1", theme.ui_color_1);
    set("--ui-color-2", theme.ui_color_2);
    set("--option-color", theme.option_color);
    set("--option-text-color", theme.option_text_color);

    // Desktop background (used for modal backgrounds)
    const deskBg = theme.background_desk ? `${process.env.REACT_APP_S3_PATH}${theme.background_desk}` : "";
    set("--desktop-bg-image", deskBg ? `url(${deskBg})` : "");
  };
    
  useEffect(() => {
      const isLoginPage = /^\/login(?:\/)?$/.test(location.pathname) || location.pathname === '/';
      if (!isLoginPage && themeStatus === "idle") {
        dispatch(fetchThemeData({ themeId: null }));
      }
  }, [themeStatus, dispatch, location.pathname]);

  useEffect(()=>{
    setBackUrl(backButtonUrl);
    setLogoUrl(companyLogoUrl);
  },[backButtonUrl,companyLogoUrl])


  useEffect(() => {
    if (themeStatus === 'succeeded' && themeData) {
      // themeset fields are on themeData root (not only themeData.colors)
      applyCustomTheme(themeData);
      const body = document.body;
      const bg = window.innerWidth <= 768 ? themeData.background_mob : themeData.background_desk;
      if (body.classList.contains('common-bg')) {
        body.style.backgroundImage = `url(${process.env.REACT_APP_S3_PATH + bg})`;
      }
    }
  }, [themeStatus, themeData]);

  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.("navigate_back");
  };

  return (
    <>
      <header className="upperaction">
      <a href={process.env.REACT_APP_BASE_URL} onClick={handleLogoClick}><img src={logoUrl} className="logo-holder" alt="" /></a>
        {!isFromMobileApp && (
          <div className="back-holder">
            {mainDaySubViewOpen ? (
              <button
                type="button"
                className="back-default"
                onClick={() => dispatch(requestBackToMainGrid())}
              >
                Back
              </button>
            ) : (
              <a href={backUrl}><button type="button" className="back-default">Back</button></a>
            )}
          </div>
        )}
       
      </header>
      {children}
    </>
  );
}

export default USER;
